import { render, staticRenderFns } from "./Donations.vue?vue&type=template&id=65334a8c&scoped=true"
import script from "./Donations.vue?vue&type=script&lang=js"
export * from "./Donations.vue?vue&type=script&lang=js"
import style0 from "./Donations.vue?vue&type=style&index=0&id=65334a8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65334a8c",
  null
  
)

export default component.exports